
// src/utils/colors.ts
import { StatusWorkflow, StatusCanal } from "../models/checagens";

export const WORKFLOW_STATUS_COLORS: Record<StatusWorkflow, string> = {
    pendente: '#64748b', // slate-500
    andamento: '#f59e0b', // amber-500
    finalizado: '#059669', // emerald-600
};

export const CANAL_STATUS_COLORS: Record<StatusCanal, string> = {
    nao_iniciado: '#64748b', // slate-400
    tentado_sem_sucesso: '#e11d48', // rose-600
    sucesso_sem_retorno: '#0ea5e9', // sky-600
    sucesso_com_retorno: '#059669', // emerald-600
};
